module.exports = __webpack_public_path__ + "media/home/about-header-img-3d392ba7.jpeg";